import React from 'react';

function ListEmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="ux-list-empty">
      {Icon && (
        <div className="ux-list-empty-icon">
          <Icon size={40} />
        </div>
      )}
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}

export default ListEmptyState;
